<template>
  <SingleSQ
    class="mb-16"
    :questionData="questionData"
    :btnWidth="160"
    :oneOption="true"
    :pendingOption="false"
    :sq_numberData="'sq_fiftyOneData'"
    :sqOptions="[52]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesFiftyOne',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 92)
      } else if (value === 3) {
        this.$emit('handleProgress', 90)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
